export const SoapNote = {
  flow: 'y',
  gap: 'A',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  state: {
    subjectiveOpen: true,
    objectiveOpen: true,
    assessmentOpen: true,
    planOpen: true,
    painScale: 5,
    subjective: '',
    objective: '',
    assessment: '',
    plan: '',
    prescriptions: ''
  },

  SubjectiveSection: {
    flow: 'y',
    gap: 'Z',
    Header: {
      flow: 'x',
      align: 'center flex-start',
      gap: 'Z',
      cursor: 'pointer',
      padding: 'Z',
      borderBottom: '1px solid inkBorder',
      onClick: (el, s) => s.update({ subjectiveOpen: !s.subjectiveOpen }),
      Arrow: {
        text: (el, s) => s.subjectiveOpen ? '▾' : '▸',
        fontSize: 'Z',
        color: 'inkSubtle'
      },
      Label: { text: '{{ subjective | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkSubtle', textTransform: 'uppercase', letterSpacing: 'X' }
    },
    Body: {
      show: (el, s) => s.subjectiveOpen,
      flow: 'y',
      gap: 'Z',
      padding: 'Z',
      ChiefComplaintLabel: { text: '{{ chiefComplaint | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      ChiefComplaint: {
        tag: 'textarea',
        placeholder: 'Describe chief complaint...',
        rows: '3',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        resize: 'vertical',
        onInput: (ev, el, s) => s.update({ subjective: el.node.value })
      },
      PainScaleWrap: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Z',
        PainLabel: { text: '{{ painScale | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
        PainValue: { text: (el, s) => `${s.painScale}/10`, fontSize: 'Z', fontWeight: '700', color: 'teal' },
        PainInput: {
          tag: 'input',
          attr: { type: 'range', min: '1', max: '10' },
          value: (el, s) => s.painScale,
          onInput: (ev, el, s) => s.update({ painScale: parseInt(el.node.value) })
        }
      }
    }
  },

  ObjectiveSection: {
    flow: 'y',
    gap: 'Z',
    Header: {
      flow: 'x',
      align: 'center flex-start',
      gap: 'Z',
      cursor: 'pointer',
      padding: 'Z',
      borderBottom: '1px solid inkBorder',
      onClick: (el, s) => s.update({ objectiveOpen: !s.objectiveOpen }),
      Arrow: {
        text: (el, s) => s.objectiveOpen ? '▾' : '▸',
        fontSize: 'Z',
        color: 'inkSubtle'
      },
      Label: { text: '{{ objective | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkSubtle', textTransform: 'uppercase', letterSpacing: 'X' }
    },
    Body: {
      show: (el, s) => s.objectiveOpen,
      flow: 'y',
      gap: 'Z',
      padding: 'Z',
      FindingsLabel: { text: '{{ clinicalFindings | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      Findings: {
        tag: 'textarea',
        placeholder: 'Document clinical findings...',
        rows: '3',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        resize: 'vertical',
        onInput: (ev, el, s) => s.update({ objective: el.node.value })
      }
    }
  },

  AssessmentSection: {
    flow: 'y',
    gap: 'Z',
    Header: {
      flow: 'x',
      align: 'center flex-start',
      gap: 'Z',
      cursor: 'pointer',
      padding: 'Z',
      borderBottom: '1px solid inkBorder',
      onClick: (el, s) => s.update({ assessmentOpen: !s.assessmentOpen }),
      Arrow: {
        text: (el, s) => s.assessmentOpen ? '▾' : '▸',
        fontSize: 'Z',
        color: 'inkSubtle'
      },
      Label: { text: '{{ assessment | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkSubtle', textTransform: 'uppercase', letterSpacing: 'X' }
    },
    Body: {
      show: (el, s) => s.assessmentOpen,
      flow: 'y',
      gap: 'Z',
      padding: 'Z',
      DiagnosisLabel: { text: '{{ diagnosis | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      Diagnosis: {
        tag: 'input',
        attr: { type: 'text' },
        placeholder: 'Enter diagnosis...',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        onInput: (ev, el, s) => s.update({ assessment: el.node.value })
      }
    }
  },

  PlanSection: {
    flow: 'y',
    gap: 'Z',
    Header: {
      flow: 'x',
      align: 'center flex-start',
      gap: 'Z',
      cursor: 'pointer',
      padding: 'Z',
      borderBottom: '1px solid inkBorder',
      onClick: (el, s) => s.update({ planOpen: !s.planOpen }),
      Arrow: {
        text: (el, s) => s.planOpen ? '▾' : '▸',
        fontSize: 'Z',
        color: 'inkSubtle'
      },
      Label: { text: '{{ plan | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkSubtle', textTransform: 'uppercase', letterSpacing: 'X' }
    },
    Body: {
      show: (el, s) => s.planOpen,
      flow: 'y',
      gap: 'Z',
      padding: 'Z',
      TreatmentLabel: { text: '{{ treatmentPlan | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      Treatment: {
        tag: 'textarea',
        placeholder: 'Describe treatment plan...',
        rows: '3',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        resize: 'vertical',
        onInput: (ev, el, s) => s.update({ plan: el.node.value })
      },
      PrescriptionsLabel: { text: '{{ prescriptions | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      Prescriptions: {
        tag: 'textarea',
        placeholder: 'List prescriptions...',
        rows: '2',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        resize: 'vertical',
        onInput: (ev, el, s) => s.update({ prescriptions: el.node.value })
      }
    }
  }
}
